import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OpenFeature } from '@openfeature/web-sdk';
import { distinctUntilChanged, startWith } from 'rxjs/operators';
import { DynamicFeatureFlagService } from 'shared/services';
import { ENABLE_VIDEO_DELIVERY_FLAG } from 'app/content/constants/video-download.constants';

@Injectable({ providedIn: 'root' })
export class VideoDeliveryFeatureService {
    private readonly dynamicFeatureFlagService = inject(DynamicFeatureFlagService);

    readonly enabled = toSignal(
        this.dynamicFeatureFlagService
            .isFeatureEnabled$(ENABLE_VIDEO_DELIVERY_FLAG)
            .pipe(
                startWith(OpenFeature.getClient().getBooleanValue(ENABLE_VIDEO_DELIVERY_FLAG, false)),
                distinctUntilChanged()
            ),
        { initialValue: false }
    );
}
